<template>
  <div class="banner-container">
    <img class="banner" v-bind:src="image"></img>
    <div class="logo-container">
      <router-link to="/home">
        <img v-bind:src="logo" class="logo">
      </router-link>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'MainBanner',
    props: {
      image: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        logo: "src/assets/images/logo/logo_1_md.png"
      };
    }
  };
</script>
<style lang="css" scoped>
  .banner-container {
    position: relative;
    width: 100vw;
    height: 600px;
    margin-left: -65px;
  }

  .banner {
    position: absolute;
    top: -80px;
    right: -200px;
    height: 100%;
    width: auto;
  }

  .logo-container {
    color: #424242;
    position: absolute;
    left: 50px;
    top: 200px;
  }

  .logo {
    width: 400px;
    max-width: 100%;
    height: 100%;
    border-radius: 100%;
    background-color: rgba(255, 255, 255, 0.1);
  }

  @media screen and (max-width: 1400px) {
    .banner-container {
      margin-left: -35px;
    }
    .logo-container {
      left: 0px;
      right: 0px;
    }
  }
</style>


// WEBPACK FOOTER //
// MainBanner.vue?cd43b9e0